<template>
    <loadtabxls @setPositions="setPositions"></loadtabxls>
    <positions :is_reduction="is_reduction" :positions="tender.positions" :tender_type="tender.tender_type"></positions>
</template>

<script>


import loadtabxls from "./fields/loadtabxls.vue";
import positions from "./positions/positions.vue";

export default {
    name: "tender_nomenclature",
    emits : ['changeAtr'],
    
    props : {
        tender : {
            type : Object
        }
    },
    
    components : {
        positions,
        loadtabxls,
    },
    
    created() {
        
        
        
        if(parseInt(this.tender.id) > 0) {
            this.init_exist_tender();
        }
    },
    
    methods : {
        
        init_exist_tender() {
            if(this.tender.hasOwnProperty('positions')) {
            
            }
        },
        
        
        setPositions(items) {
            this.tender.positions = [];
            items.map(item => {
                this.tender.positions.push(item);
            })
        }
    },
    
    computed : {
        is_reduction() {
            return this.tender.tender_type === 'second_reduction';
        }
    },
    
    
    
    
    
}
</script>



<style scoped>

</style>